import AboutContainer from './components/AboutContainer';
import './assets/scss/main.css';

export default AboutContainer;


// WEBPACK FOOTER //
// ./src/features/About/index.js